// src/Context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getUser as apiGetUser,
  logoutUser as apiLogout,
  loginData as apiLogin,
   refreshToken as apiRefreshToken
} from "../Services/Api";


const AuthContext = createContext();


export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);


// ---------------------------------------------------------------------------------------------

useEffect(() => {
  const hydrate = async () => {
    setAuthLoading(true);

    try {
      const data = await apiGetUser();
      setUser(data.user);
    } catch (err) {
      if (err?.response?.status === 401) {
        try {
          await apiRefreshToken();    
          const data = await apiGetUser();
          setUser(data.user);
        } catch (refreshErr) {
          setUser(null);
        }
      } else {
        setUser(null);
      }
    } finally {
      setAuthLoading(false);
    }
  };

  hydrate();
}, []);




  // ---------------------------------------------------------------------------------------------

  const login = async (credentials) => {
    setAuthLoading(true);
    try {
      const data = await apiLogin("login", credentials);

      if (data?.user) {
        setUser(data.user);
        console.log(`user data ${user}`)
      } else {
        const up = await apiGetUser("user", { credentials: "include" });
        if (up?.user) setUser(up.user);
      }

      return data;
    } catch (err) {
      console.error("Login failed:", err);
      throw err;
    } finally {
      setAuthLoading(false);
    }
  };



  // ---------------------------------------------------------------------------------------------
  
  const logout = async () => {
    try {
      await apiLogout();
    } catch (err) {
      console.error("Logout failed API:", err);
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, authLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
